import React, { Component } from 'react';
import Navigation from './components/navigation';

import Header from './components/header';
// import Features from './components/features'; // optional
import About from './components/about';
import Services from './components/services'; // ✅ correct lowercase s
import Reviews from './components/Reviews'; 
// import Showcase from './components/Showcase'; // ❌ don't use
import Gallery from './components/gallery';
import Testimonials from './components/testimonials';
import Team from './components/Team';
import Contact from './components/contact';
import JsonData from './data/data.json';

export class App extends Component {
  state = {
    landingPageData: {},
  };

  getlandingPageData() {
    this.setState({ landingPageData: JsonData });
  }

  componentDidMount() {
    this.getlandingPageData();
  }

 render() {
  const data = this.state.landingPageData;

  return (
    <div>
      <Navigation />
<Header data={this.state.landingPageData.Header} />
<About data={this.state.landingPageData.About} />
<Services data={this.state.landingPageData.Services} />

{/* You can keep or remove Testimonials/Team as you like */}
{/* <Testimonials data={this.state.landingPageData.Testimonials} /> */}
{/* <Team data={this.state.landingPageData.Team} /> */}

<Reviews />   {/* ← add this line */}
<Contact data={this.state.landingPageData.Contact} />

    </div>
  );
}

}

export default App;
